import gql from 'graphql-tag'
import { COMPANY_RECRUITER_FRAGMENT } from '@/components/Contacts/CompanyRecruiter/queries/CompanyRecruiters'

export const UpdateCompanyRecruiterMutation = gql`
  mutation ($input: UpdateCompanyRecruiterInput!) {
    updateCompanyRecruiter(input: $input) {
      ...CompanyRecruiterFragment
    }
  }
  ${COMPANY_RECRUITER_FRAGMENT}
`
